export default {
	
	GET_POWER_BI_REPORT: undefined,
	GET_POWER_BI_REPORT_SUCCESS: undefined,
	GET_POWER_BI_REPORT_FAILURE: undefined,

	CLEAR_POWER_BI_STATE: undefined
}